import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";

export class UyapTakipTevziAlTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip = UyapTakipAc.fromJson(task.data);
            await takip.takipBaslat(false,false);
            task.response = takip;
            // Harç muaf dosyada takip bu görevde açılır; açıldıktan sonra hash kaydı güncellenemezse
            // görev hatalı değil, eksik biter ve neden açıklamaya yazılır (DEV-3302).
            // icraProSenkronHatasi burada bilerek okunmuyor: yalnız tevzi alınan (açılmamış) dosyada
            // da kart senkronu denenebiliyor (MTS'te esas no yerine "Dosya tevzi alındı..." metniyle);
            // bayrak dolarsa EKSIK satır "Seçilen Takipleri Aç" listesinden düşerdi.
            task.status = takip.hashGuncellemeHatasi ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            if (task.status == TaskDurum.BITTI_EKSIK)
                task.description = takip.eksikBitisAciklamasi(false);
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message);
        }
    }

}